import Vue from 'vue'
import App from './App.vue'
import router from '@/router'

// 401 INTERCEPT
import intercetor from "@/helpers/interceptor";
intercetor.status401();
intercetor.acceptJsonOnly();

// FONTAWESOME
import { library } from "@fortawesome/fontawesome-svg-core";
import { faStream, faCog, faPlusSquare, faFileCsv, faKey, faEdit, faBars, faSignOutAlt, faCrow, faNetworkWired, faChartBar, faClipboardCheck, faShieldAlt, faClock, faSearch, faCheckSquare, faChevronDown, faTimes, faSpinner, faChartLine, faSave, faHeart, faSquare, faCircle, faHeartBroken, faFilter, faUser, faUserPlus, faFileExport, faSlidersH, faExclamationTriangle, faUsersCog, faUserTag, faEyeSlash, faCaretDown, faTimesCircle, faBackspace, faDownload, faLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add( faExclamationTriangle, faStream, faCog, faSlidersH, faPlusSquare,faFileCsv, faKey, faEdit, faBars, faSignOutAlt, faCrow, faNetworkWired, faChartBar, faClipboardCheck, faShieldAlt, faClock, faSearch, faCheckSquare, faChevronDown, faTimes, faSpinner, faChartLine, faSave, faHeart, faSquare, faCircle, faHeartBroken, faFilter, faUser, faUserPlus, faFileExport, faUsersCog, faUserTag, faEyeSlash, faCaretDown, faTimesCircle, faBackspace, faDownload, faLink);
Vue.component("font-awesome-icon", FontAwesomeIcon);

// CONTAINER CUSTOM COMPONENT
import { LContainer, LContainerTitle, LContainerToolbar } from "@/components/container";
Vue.component("l-container", LContainer);
Vue.component("l-container-toolbar", LContainerToolbar);
Vue.component("l-container-title", LContainerTitle);

// TOASTIFY
import VueToastify from 'vue-toastify';
Vue.component('vue-toastify', VueToastify);
window.EventBus = new Vue();

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
